var getBoxShadow = function (size) {
    switch (size) {
        case 1:
            return '0px 1px 2px rgba(0, 0, 0, 0.2)';
        case 2:
            return '0px 1px 2px rgba(0, 0, 0, 0.08), 0px 2px 6px rgba(0, 0, 0, 0.1)';
        case 3:
            return '0px 4px 12px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.08)';
        case 4:
            return ' 0px 8px 24px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.08)';
        case 5:
            return '0px 18px 48px rgba(0, 0, 0, 0.2), 0px 1px 2px rgba(0, 0, 0, 0.08)';
        case 6:
            return '0px 1px 1px rgba(0, 0, 0, 0.15), 0px 3px 6px rgba(0, 0, 0, 0.15)';
        default:
            return 'none';
    }
};
var sonikaTheme = {
    colors: {
        primary: '#0C2AF3',
        primaryHover: '#0B26DB',
        primaryLight: '#DEEFFF',
        secondary: '#FD544F',
        secondaryHover: '#E44C47',
        secondaryLight: '#FDEBDB',
        divider: '#D5D6D8',
        background: {
            primary: '#F8F9FA',
            secondary: '#FFFFFF',
            tertiary: '#f2f4f6',
        },
        foreground: {
            primary: '#131313',
            separation: '#D5D6D8',
            secondary: '#484848',
            placeholder: '#848484',
            tertiary: '#6A6A6A',
        },
        system: {
            go: '#57be56',
            goHover: '#40a23f',
            stop: '#fd544f',
            stopHover: '#fc231d',
            wait: '#FD8F27',
            waitHover: '#ffff0f',
        },
    },
    breakPoints: {
        low: '768px',
    },
    fontFamily: 'Inter, sans-serif',
    helpers: {
        pxToRem: function (size) { return size / 16 + "rem"; },
        spacing: function (factor) { return (4 * factor) / 16 + "rem"; },
        shadow: function (size) { return getBoxShadow(size); },
    },
};

export { sonikaTheme as s };
//# sourceMappingURL=sonikaTheme-c58de996.js.map
